import { useEffect, useState } from "react";
import style from "./index.module.scss";
import UnionIcon from "../assets/union.svg";
import CloseIcon from "../assets/close.svg";
import AudioIcon from "../assets/audio.svg";
import FileIcon from "../assets/file.svg";
import ImageIcon from "../assets/image.svg";
import AudioUploadIcon from "../assets/audio-upload.svg";
import FileUploadIcon from "../assets/file-upload.svg";
import DeleteIcon from "../assets/delete.svg";
import { Button, Popup, SafeArea, Toast } from "antd-mobile";
import classnames from "classnames";
import { callbackSmsUrl } from "../../../network/octopusApi";
import { useHistory, useParams } from "react-router-dom";

const FileUpload = () => {
  const { token } = useParams<{ token: string }>();
  const history = useHistory();

  const [fileList, setFileList] = useState<File[]>([]);
  const [uploadVisible, setUploadVisible] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // 上传处理
  const handleUpload = (e) => {
    const { files } = e.target;
    if (files[0]?.size > 1024 * 1024 * 20) {
      return Toast.show("上传的文件大小不得超过20M");
    }

    setFileList([...fileList, files[0]]);
    setUploadVisible(false);
    e.target.value = "";
  };

  // 删除文件
  const handleDelete = (index) => {
    const arr = [...fileList];
    arr.splice(index, 1);
    setFileList(arr);
  };

  // 报错信息处理
  const handleErrMsg = (msg) => {
    const arr = msg.split(";");
    return arr[0];
  };

  // 提交
  const handleSubmit = async () => {
    const formData = new FormData();

    fileList?.forEach((item) => {
      formData.append("files", item);
    });

    const phone = sessionStorage.getItem("phone");
    const code = sessionStorage.getItem("code");
    const params = {
      phone,
      code,
    };
    setSubmitLoading(true);
    try {
      const res = await callbackSmsUrl(token, params, formData);
      setSubmitLoading(false);
      const { data, msg } = res.data;
      if (data) {
        setFileList([]);
        history.replace({
          pathname: `/octopus/result/${token}`,
          state: {
            status: "success",
          },
        });
      } else {
        history.replace({
          pathname: `/octopus/result/${token}`,
          state: {
            status: "fail",
            msg: handleErrMsg(msg),
          },
        });
      }
    } catch {
      setSubmitLoading(false);
    }
  };

  useEffect(() => {
    document.title = "文件上传";
    const isVerify = () => {
      const phone = sessionStorage.getItem("phone");
      const code = sessionStorage.getItem("code");
      if (!phone || !code) {
        history.replace(`/octopus/verify/${token}`);
        return;
      }
    };
    isVerify();
  }, [history, token]);

  return (
    <div className={style.fileUploadPage}>
      <div className={style.tip}>单个文件最大不超过20m，最多上传5个文件</div>
      <div className={style.fileUploader}>
        {fileList.map((item, index) => {
          const { type } = item || {};
          let src = "";
          if (type.indexOf("image") !== -1) {
            src = URL.createObjectURL(item);
          } else if (type.indexOf("audio") !== -1) {
            src = AudioUploadIcon;
          } else {
            src = FileUploadIcon;
          }
          return (
            <div className={style.uploadBox} key={index}>
              <img
                alt=""
                src={src}
                className={classnames({
                  [style.image]: type.indexOf("image") !== -1,
                })}
              />
              <img
                alt="deleteIcon"
                src={DeleteIcon}
                className={style.deleteIcon}
                onClick={() => handleDelete(index)}
              />
            </div>
          );
        })}
        {fileList.length < 5 && (
          <div
            className={style.uploadBtn}
            onClick={() => setUploadVisible(true)}
          >
            <img src={UnionIcon} alt="unionIcon" />
            <div className={style.uploadText}>上传文件</div>
          </div>
        )}
      </div>
      <div className={style.footer}>
        <Button
          block
          size="large"
          disabled={!fileList.length}
          loading={submitLoading}
          onClick={handleSubmit}
        >
          提交
        </Button>
        <SafeArea position="bottom" />
      </div>
      <Popup
        visible={uploadVisible}
        onMaskClick={() => {
          setUploadVisible(false);
        }}
        bodyClassName={style.uploadPopup}
      >
        <div className={style.header}>
          <div
            className={style.closeBtn}
            onClick={() => setUploadVisible(false)}
          >
            <img src={CloseIcon} alt="closeIcon" />
          </div>
        </div>
        <div className={style.content}>
          <div className={style.item}>
            <img src={ImageIcon} alt="imageIcon" />
            <div className={style.text}>图片</div>
            <input
              type="file"
              accept="image/*"
              className={style.fileInput}
              onChange={handleUpload}
            />
          </div>
          <div className={style.item}>
            <img src={AudioIcon} alt="audioIcon" />
            <div className={style.text}>音频</div>
            <input
              type="file"
              accept="audio/*"
              className={style.fileInput}
              onChange={handleUpload}
            />
          </div>
          <div className={style.item}>
            <img src={FileIcon} alt="fileIcon" />
            <div className={style.text}>文件</div>
            <input
              type="file"
              accept="*"
              className={style.fileInput}
              onChange={handleUpload}
            />
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default FileUpload;
